module.exports = __webpack_public_path__ + "img/Jack_in_the_Box_logo.8b822b53.svg";